var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"save-button-wrap"}},[_c('button',{attrs:{"id":"save"},on:{"click":_vm.saveCharacter}},[_vm._v("Save")]),(!_vm.noClear)?_c('button',{attrs:{"id":"clear"},on:{"click":_vm.clearCharacter}},[_vm._v("Clear")]):_vm._e(),_c('p',{style:(_vm.saveStateStyle)},[_vm._v(_vm._s(_vm.saveState))])])
}
var staticRenderFns = []

export { render, staticRenderFns }